// extracted by mini-css-extract-plugin
export default {"business_tooltip":"PackageTooltip_business_tooltip__0KvVX"};